import React from 'react'
import { BaseSvgIcon, BaseSvgIconProps } from './base-svg-icon'

// A side panel with a chevron pointing toward it: "close the left panel"
export const PanelLeftCloseIcon = ({
  className,
  color,
  size,
  title,
  strokeWidth,
  ...rest
}: BaseSvgIconProps) => {
  return (
    <BaseSvgIcon
      className={className}
      fill="none"
      size={size}
      viewBox="0 0 16 16"
      {...rest}>
      {title && <title>{title}</title>}
      <g
        stroke={color || 'currentColor'}
        strokeWidth={strokeWidth || 1}
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect x="2" y="2.5" width="12" height="11" rx="2" />
        <path d="M6 2.5v11M10.5 6L8.5 8l2 2" />
      </g>
    </BaseSvgIcon>
  )
}
